import React, { Fragment, useState } from "react"
import { useDispatch } from "react-redux"
import { FaCheckCircle } from "react-icons/fa"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { editOfflineOrder } from "@redux"
import { ConfirmationModal, IconButton } from "components"
import classes from "./OfflineOrderDetailsCompleteButton.module.scss"

const OfflineOrderDetailsCompleteButton = props => {
  const { offlineOrder, setOfflineOrder } = props

  const [t, i18n] = useTranslation()

  const dispatch = useDispatch()

  const [showConfirmationModal, setShowConfirmationModal] = useState(false)

  const handleCompleteOrder = async () => {
    dispatch(
      editOfflineOrder(
        offlineOrder.offlineOrderId,
        { orderStatus: "delivered" }
      )
    )

    setOfflineOrder(prev => ({
      ...prev,
      orderStatus: "delivered"
    }))
  }

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Fragment>
      <div
        className={classes["container"]}
        onClick={() => setShowConfirmationModal(true)}
      >
        <IconButton
          icon={FaCheckCircle}
          size={18}
          color="var(--color-success)"
          loadingColor="black"
        />
        <span
          className={clsx(
            classes["text"],
            isLtr && classes["text-ltr"]
          )}
        >
          {t("تکمیل_سفارش")}
        </span>
      </div>

      <ConfirmationModal
        title={t("آیا_می_خواهید_این_سفارش_را_تکمیل_کنید")}
        show={showConfirmationModal}
        onConfirm={handleCompleteOrder}
        onHide={() => setShowConfirmationModal(false)}
      />
    </Fragment>
  )
}

export default OfflineOrderDetailsCompleteButton